import { ReportingBookmarkDto } from '@vori/dashboard-rest-next/schemas/reportingBookmarkDto'
import { FormInitialValues } from '@vori/react-form'
import { FormFieldType } from 'web/react-form/src/types/form-field'

export enum OldReportingTab {
  OVERVIEW = 'overview',
  ENDOFDAY = 'end-of-day',
  PROMOTIONS = 'promotions',
  REPORTS = 'reports',
  TILLS = 'tills',
  TRANSACTIONS = 'transactions',
}

export enum ReportingTab {
  SALES = 'sales',
  FINANCES = 'finances',
  INVENTORY = 'inventory',
  POS = 'point-of-sale',
  SHOPPERS = 'shoppers',
}

export type ReportingSubsection = {
  label: string
  embedID: string
  workbookID: string
}

export const REPORTING_SECTIONS: Record<
  ReportingTab,
  Record<string, ReportingSubsection>
> = {
  [ReportingTab.SALES]: {
    overview: {
      label: 'Sales Overview',
      embedID: '72oC7hKr0AtoTI2dLU67L2',
      workbookID: '4ZcP6m6VuXmvaHqCkrh0KQ',
    },
    trends: {
      label: 'Sales Trends',
      embedID: 'M55VbP8Q5kyhdBo6Hv3Uz',
      workbookID: '2LmW0WBLCXq8T49kBSxeoA',
    },
    'items-sales': {
      label: 'Item Sales',
      embedID: '6AC790P2u5CQRwGp9rNUBS',
      workbookID: '45kytv1wGK0hS58W0jDnOA',
    },
    promotions: {
      label: 'Promotions',
      embedID: '40Oi12R4XxsArTBmhBtey6',
      workbookID: '3hTK2S4kHk5VL5zYGGJYh2',
    },
    'suspended-orders': {
      label: 'Suspended Orders',
      embedID: '1tpNAz4Lu47KVp3NdShurX',
      workbookID: 'KgIyuezuvpJ2ingqfvxNf',
    },
    'department-sales': {
      label: 'Department Sales',
      embedID: '1il6tXGPg6Kb9NXk9MIKL6',
      workbookID: '68JfZZiUOG0QwZoo38EvaA',
    },
    'end-of-month': {
      label: 'End of Month',
      embedID: '5r5wpdAtdLsxVNxe5F5iJs',
      workbookID: '3uhSVIRCG2CZySXXy0WgE8',
    },
  },
  [ReportingTab.FINANCES]: {
    payments: {
      label: 'Payments',
      embedID: '2amnp93cNA3mg0DqdHFiJ6',
      workbookID: '7Kq6izbh3j4oI8HcOyF4eY',
    },
    taxes: {
      label: 'Taxes',
      embedID: '5rX7mEs0b3EPDNslO8Qnaz',
      workbookID: '1b6AiaPVG6m8uz7GWO3UEf',
    },
    'bottle-deposits': {
      label: 'Bottle Deposits',
      embedID: '2tmsJdOHX0Tyoozfomm3Y4',
      workbookID: '34obRVDkMhz3vkZk6172BM',
    },
    'gift-cards': {
      label: 'Gift Cards',
      embedID: '3vMePDzy7budlT5bvTJJ1k',
      workbookID: '3tXZWfXcWNPIbxr0YeQ48I',
    },
    'house-accounts-overview': {
      label: 'House Accounts Overview',
      embedID: '4f48dPsfNjPGgBv7tKFk2c',
      workbookID: '3TwLzVz2L6wwlmg12ZOiQi',
    },
    'house-account-statement': {
      label: 'House Account Statement',
      embedID: '67bbvJuZMCRW4YzM38DfTc',
      workbookID: '7odnYYp2w104rOoY2QW3RS',
    },
  },
  [ReportingTab.INVENTORY]: {
    'vendor-report-card': {
      label: 'Vendor Report Card',
      embedID: '55rPuKAkJ1OQhKCEZ7OOyq',
      workbookID: '5KYcWsc6IuYHrzGYiub1Ai',
    },
    'purchase-orders': {
      label: 'Purchase Orders',
      embedID: '4fxAZaFCz2WN08kdToz74E',
      workbookID: '6mpRR5RiAsbzK55f1IDqhW',
    },
    products: {
      label: 'Products',
      embedID: '4JjKYHVxzmC8UVPncwhskZ',
      workbookID: 'Icjj2yqpdzGtTXGFgBhWu',
    },
    'inventory-levels': {
      label: 'Inventory Levels',
      embedID: '2oBbnXCQN8Kr66BQqKeppL',
      workbookID: 'urlprOW8bneb6btBoBcws',
    },
    'inventory-history': {
      label: 'Inventory History',
      embedID: '5W92vcHPMG8GjSRMHQejpI',
      workbookID: '4dNGP6w1vYSNYlRNP6VdbE',
    },
    'vendor-item-sales': {
      label: 'Vendor Item Sales',
      embedID: '2qAOe2XZj4sprWG0Kl22m6',
      workbookID: '7pZjNhlY5iwf40kFLw4x4S',
    },
  },
  [ReportingTab.POS]: {
    'till-trends': {
      label: 'Till Trends',
      embedID: '3O2OOg8onBvPUksZjXHSzs',
      workbookID: '2FmjNjgYNHnWYm7lGgD3xb',
    },
    'till-movements': {
      label: 'Till Pay-Ins & Pay-Outs',
      embedID: '2NABxHlw9q0FLhcmYDxbYv',
      workbookID: '3XqtWVSaW5q7bniFdh8ODe',
    },
    'cashiers-overview': {
      label: 'Cashiers Overview',
      embedID: '4wgrxvjWqvj4dQvuO8cNB9',
      workbookID: '6ng0CA0AOLlbWjzRA3NNKJ',
    },
    'individual-cashier-report': {
      label: 'Cashier Report Card',
      embedID: '3w4ZoYzHrcRglg8o5FF7mt',
      workbookID: '2XbpBPo7nj4EtHIxc1m6dO',
    },
    'manual-items-usage': {
      label: 'Manual Items Usage',
      embedID: 'It88yBXqo6usFdPRrWit3',
      workbookID: '6QupW9NPOEK1hXAhSmsC7u',
    },
    'discounts-usage': {
      label: 'Discounts Usage',
      embedID: '1jWIcLgYRvpVWb9yZUq9QY',
      workbookID: 'A94ia8wtzIZKndK11JJju',
    },
  },
  [ReportingTab.SHOPPERS]: {
    'shopper-trends': {
      label: 'Shopper Trends',
      embedID: 'VeDzU6X1vLhNydBkkbSzM',
      workbookID: '5LZTHlHeyRrM3og1CZdtnd',
    },
    loyalty: {
      label: 'Loyalty',
      embedID: '7dXHxGMo5Oa4f38GgEhKhT',
      workbookID: '3jcQRjU2xujxAKTpKh8ECh',
    },
    campaigns: {
      label: 'Campaigns',
      embedID: '50ANQUgYcjj7JozB4WqyC1',
      workbookID: '4wB2ArYRoLdtCcxJXMaFVy',
    },
  },
}

export type ScheduledExportFormSchema = {
  recipient_emails: Extract<FormFieldType, 'text'>
  frequency: Extract<FormFieldType, 'select'>
  send: Extract<FormFieldType, 'select'>
  send_time: Extract<FormFieldType, 'text'>
  timezone: Extract<FormFieldType, 'select'>
}

export enum ScheduleFrequency {
  MONTHLY = 'Monthly',
  WEEKLY = 'Weekly',
  DAILY = 'Daily',
}

export enum ScheduledExportModalMode {
  CREATE,
  LIST,
  UPDATE,
}

export type SelectedScheduledExport =
  FormInitialValues<ScheduledExportFormSchema> & { id: string }

export const SIGMA_EVENT_ORIGIN = 'https://app.sigmacomputing.com'

export type ReportingBookmark = Omit<
  ReportingBookmarkDto,
  'created_at' | 'updated_at' | 'sigma_bookmark_id'
>

const QUARTER_TO_DATE_BOOKMARK: ReportingBookmark = {
  id: 'quarter-to-date',
  name: 'Quarter to Date',
  control_variables: {
    date_range: 'Quarter%20to%20Date',
  },
}

// these are the variables that are set in the iframe whenever no default bookmark is set
export const DEFAULT_DEFAULT_BOOKMARKS: Record<
  ReportingTab,
  Record<string, ReportingBookmark | undefined>
> = {
  [ReportingTab.SALES]: {
    overview: {
      id: 'quarter-to-date',
      name: 'Quarter to Date',
      control_variables: {
        date_range: 'Quarter%20to%20Date',
        metric_sales: 'Net%20Sales',
        departments: 'Top%2010',
        'sub-departments': 'Top%2010',
      },
    },
    trends: {
      id: 'net-sales',
      name: 'Net Sales',
      control_variables: {
        metric_trend: 'Net%20Sales',
        comp_month: 'Same%20Month%20Last%20Year',
        month_base: 'Current%20Year',
        week_base: 'Last%2012%20Weeks',
        'comp-week': 'Previous%20Period',
        comp: 'Previous%20Period',
        base: 'Current%20Week',
      },
    },
    'items-sales': {
      id: 'quarter-to-date',
      name: 'Quarter to Date',
      control_variables: {
        date_range: 'Quarter%20to%20Date',
        Drilldown_1: 'Department',
        Drilldown_2: 'Sub-Department',
        metric: 'Product%20Name',
      },
    },
    promotions: QUARTER_TO_DATE_BOOKMARK,
    'suspended-orders': QUARTER_TO_DATE_BOOKMARK,
    'department-sales': QUARTER_TO_DATE_BOOKMARK,
    'end-of-month': {
      id: 'previous-month',
      name: 'Previous Month',
      control_variables: {
        date_range: 'Previous%20Month',
      },
    },
  },
  [ReportingTab.FINANCES]: {
    payments: QUARTER_TO_DATE_BOOKMARK,
    'bottle-deposits': QUARTER_TO_DATE_BOOKMARK,
    'gift-cards': QUARTER_TO_DATE_BOOKMARK,
    'house-accounts-overview': QUARTER_TO_DATE_BOOKMARK,
    'house-account-statement': {
      id: 'previous-month',
      name: 'Previous Month',
      control_variables: {
        date_range: 'Previous%20Month',
      },
    },
  },
  [ReportingTab.INVENTORY]: {
    'vendor-report-card': QUARTER_TO_DATE_BOOKMARK,
    'inventory-history': {
      id: 'quarter-to-date',
      name: 'Quarter to Date',
      control_variables: {
        date_range: 'Quarter%20to%20Date',
        Status: 'Active',
      },
    },
    'vendor-item-sales': {
      id: 'quarter-to-date',
      name: 'Quarter to Date',
      control_variables: {
        date_range: 'Quarter%20to%20Date',
        Vendor: '',
        metric: 'Product%20Name',
        Drilldown_2: 'Department',
        Drilldown_1: 'Vendor',
      },
    },
  },
  [ReportingTab.POS]: {
    'till-trends': QUARTER_TO_DATE_BOOKMARK,
    'till-movements': QUARTER_TO_DATE_BOOKMARK,
    'cashiers-overview': QUARTER_TO_DATE_BOOKMARK,
    'individual-cashier-report': QUARTER_TO_DATE_BOOKMARK,
    'manual-items-usage': {
      id: 'quarter-to-date',
      name: 'Quarter to Date',
      control_variables: {
        date_range: 'Quarter%20to%20Date',
        cashiers: 'Top%2010',
      },
    },
    'discounts-usage': {
      id: 'quarter-to-date',
      name: 'Quarter to Date',
      control_variables: {
        date_range: 'Quarter%20to%20Date',
        cashiers: 'Top%2010',
        Drilldown_1: 'Cashier',
        Drilldown_2: 'Department',
      },
    },
  },
  [ReportingTab.SHOPPERS]: {
    'shopper-trends': QUARTER_TO_DATE_BOOKMARK,
    loyalty: QUARTER_TO_DATE_BOOKMARK,
  },
}
